import { RootDispatch } from "store";
import {
  Notification,
  showNotification,
} from "store/notification/notification-slice";

export const addNotification = (
  dispatch: RootDispatch,
  isSlideOpen: boolean,
  notification: Omit<Notification, "id" | "slideout">
): string => {
  const action = showNotification({
    ...notification,
    slideout: isSlideOpen,
  });
  dispatch(action);
  return action.meta.id;
};
